class CerelleHeroMedia extends HTMLElement {
  constructor() {
    super();
    this.mobileMedia = window.matchMedia('(max-width: 749px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleMediaChange = this.update.bind(this);
    this.handlePlaying = this.handlePlaying.bind(this);
    this.handlePlaybackFailure = this.handlePlaybackFailure.bind(this);
  }

  connectedCallback() {
    this.videoLayers = Array.from(this.querySelectorAll('[data-hero-video]'));

    this.videoLayers.forEach((layer) => {
      const video = layer.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.addEventListener('playing', this.handlePlaying);
      ['abort', 'emptied', 'error', 'stalled'].forEach((eventName) => {
        video.addEventListener(eventName, this.handlePlaybackFailure);
      });
    });

    this.addMediaListener(this.mobileMedia);
    this.addMediaListener(this.reducedMotion);
    this.update();
  }

  disconnectedCallback() {
    this.removeMediaListener(this.mobileMedia);
    this.removeMediaListener(this.reducedMotion);

    this.videoLayers?.forEach((layer) => {
      const video = layer.querySelector('video');
      if (!video) return;

      video.pause();
      video.removeEventListener('playing', this.handlePlaying);
      ['abort', 'emptied', 'error', 'stalled'].forEach((eventName) => {
        video.removeEventListener(eventName, this.handlePlaybackFailure);
      });
    });
  }

  addMediaListener(mediaQuery) {
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', this.handleMediaChange);
    } else {
      mediaQuery.addListener(this.handleMediaChange);
    }
  }

  removeMediaListener(mediaQuery) {
    if (mediaQuery.removeEventListener) {
      mediaQuery.removeEventListener('change', this.handleMediaChange);
    } else {
      mediaQuery.removeListener(this.handleMediaChange);
    }
  }

  handlePlaying(event) {
    const layer = event.currentTarget.closest('[data-hero-video]');
    if (layer === this.activeLayer) layer.classList.add('is-playing');
  }

  handlePlaybackFailure(event) {
    event.currentTarget.closest('[data-hero-video]')?.classList.remove('is-playing');
  }

  update() {
    const activeBreakpoint = this.mobileMedia.matches ? 'mobile' : 'desktop';
    this.activeLayer = this.reducedMotion.matches
      ? null
      : this.videoLayers.find((layer) => layer.dataset.heroVideo === activeBreakpoint);

    this.videoLayers.forEach((layer) => {
      const video = layer.querySelector('video');
      if (!video) return;

      if (layer !== this.activeLayer) {
        video.pause();
        video.preload = 'none';
        layer.classList.remove('is-playing');
        return;
      }

      video.preload = 'metadata';
      if (!video.dataset.heroLoaded) {
        video.dataset.heroLoaded = 'true';
        video.load();
      }

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => layer.classList.remove('is-playing'));
      }
    });
  }
}

if (!customElements.get('cerelle-hero-media')) {
  customElements.define('cerelle-hero-media', CerelleHeroMedia);
}
